import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontBarlow, fontBarlowSemiCondensed } from "@product/scmp-sdk";

import { AuthorName } from "~/components/author/author-name";

export const Container = styled.div``;

export const AuthorNameContainerLabel = styled.span`
  font-weight: 700;
`;

type AuthorNameContainerProps = {
  $isMultipleAuthor: boolean;
};
export const AuthorNameContainer = styled.div<AuthorNameContainerProps>`
  display: flex;
  flex-wrap: wrap;
  gap: 4px 6px;
  justify-content: center;
  align-items: center;

  color: #222222;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontBarlowSemiCondensed};
  line-height: 16.8px;
  letter-spacing: 0.05em;
  white-space: nowrap;
  text-transform: uppercase;

  ${props => props.theme.breakpoints.up("desktop")} {
    font-size: 16px;
    line-height: 19.2px;
  }

  ${props =>
    props.$isMultipleAuthor &&
    css`
      gap: 4px 0;
      ${AuthorNameContainerLabel} {
        inline-size: 100%;
      }
    `}
`;

export const AuthorNameWrapper = styled.span`
  & + & {
    &::before {
      content: "/";

      margin-inline: 4px;
    }
  }
`;

export const StyledAuthorName = styled(AuthorName)`
  color: #222222;
`;

export const ArticleDateContainer = styled.div`
  margin-block-start: 4px;

  color: #a1a1a1;
  font-weight: 600;
  font-size: 14px;
  font-family: ${fontBarlow};
  font-style: normal;
  line-height: normal;
  text-transform: capitalize;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-start: 24px;
  }
`;
